import styled, { css } from 'styled-components'

import { FormControlLabel } from '@components/ui'

const sharedFormControlLabelStyles = css`
  white-space: nowrap;

  &:has(.onlySelected):has(input:disabled) > span:last-child {
    color: ${({ theme }) => theme.colors.gray[100]};
  }
`

export const FilterFormFormControlLabel = styled(FormControlLabel)`
  ${sharedFormControlLabelStyles}

  & > span:last-child {
    font-weight: 700;
    color: ${({ theme }) => theme.colors.gray[100]};
  }
`

export const FilterWidgetFormControlLabel = styled(FormControlLabel)`
  ${sharedFormControlLabelStyles}

  & > span:last-child {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.gray[100]};
    height: 30px;
    display: flex;
    align-items: center;
  }
`
